import {
  ALLOWED_MEDIA_TYPE_MIMES,
  DEFAULT_SLIDESHOW_FOLDER_NAME,
  FileModel,
  MediaTypesEnum,
} from 'dash-common';
import { Icon, Video, FileTypeIcon } from 'dash-ui';
import { useTheme } from 'styled-components';
import { Media } from 'gql/generated.graphql';

import { ViewedFileTypes } from 'containers/properties/PropertyMedia/components/MediaFilesView/components/MediaFilesList/components/MediaFileItem/MediaFileItem.constants';
import { ThumbnailView } from 'containers/properties/PropertyMedia/components/MediaFilesView/components/MediaFilesList/components/MediaFileItem/MediaFileItem.styles';

const ViewFileContainer = ({
  media,
  isFolder,
}: {
  media?: Media;
  isFolder: boolean;
}) => {
  const mediaFile =
    media?.type === MediaTypesEnum.FILE &&
    media?.files.length &&
    media.files[0];
  const theme = useTheme();
  const isVideo =
    mediaFile &&
    [
      ALLOWED_MEDIA_TYPE_MIMES.avi,
      ALLOWED_MEDIA_TYPE_MIMES.mp4,
      ALLOWED_MEDIA_TYPE_MIMES.mov,
    ].includes(mediaFile.type);

  if (isFolder) {
    return (
      <Icon
        name={
          DEFAULT_SLIDESHOW_FOLDER_NAME === media?.folderName
            ? 'lock'
            : 'folder'
        }
        color={theme.colors.n60}
        size={45}
      />
    );
  }

  if (isVideo) {
    return <Video src={mediaFile.publicUrl} />;
  }

  if (
    mediaFile &&
    ViewedFileTypes.some((item) => mediaFile.type.includes(String(item)))
  ) {
    return (
      <ThumbnailView
        fit="cover"
        src={mediaFile.thumbnailFile?.publicUrl || mediaFile.publicUrl}
      />
    );
  }

  if (mediaFile && ALLOWED_MEDIA_TYPE_MIMES.pdf === mediaFile.type) {
    return <FileTypeIcon file={mediaFile as FileModel} />;
  }

  return <Icon name="filePlaceholder" size={45} color={theme.colors.n20} />;
};

export default ViewFileContainer;
